import configJson from '../config/config.json';

const appConfig = {
    lastUpdate: configJson.lastUpdate,
    environmentName: configJson.environmentName,
    baseApiEndpoint: configJson.baseApiEndpoint
};

const azureAdMsal = {
    auth: {
        clientId: configJson.azureAdMsalConfig.auth.clientId,
        authority: configJson.azureAdMsalConfig.auth.authority,
        redirectUri: configJson.azureAdMsalConfig.auth.redirectUri,
        postLogoutRedirectUri: configJson.azureAdMsalConfig.auth.redirectUri
    },
    cache: {
        cacheLocation: configJson.azureAdMsalConfig.cache.cacheLocation,
        storeAuthStateInCookie: configJson.azureAdMsalConfig.cache.storeAuthStateInCookie
    },
    scope: {
        scopes: configJson.azureAdMsalConfig.scope.scopes
    }
};

const configService = {
    appConfig,
    azureAdMsal
};

export default configService;
